import * as React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { sortBy } from "lodash";

import { loadEvents, EventsState } from "web_modules/Events/redux";
import { getHurdleName } from "web_modules/Events/shared";

import { isHurdleNoteKind } from "web_modules/underwriter_dashboard/NotesScreen/shared";

const { FormattedDate } = require("react-intl");

const styles = require("./styles.module.scss");

const sortByMostRecent = notes => sortBy(notes, n => -moment(n.created_at));

interface IProps {
  appId: number;
  loadEvents?: (id: number) => void;
  events?: EventsState;
}

class NotesList extends React.Component<IProps, any> {
  componentDidMount() {
    const { events, loadEvents, appId } = this.props;

    if (!events.loading && !events.TRUSEvents) {
      loadEvents(appId);
    }
  }

  render() {
    const {
      events: { loading, TRUSEvents },
    } = this.props;

    if (loading && !TRUSEvents) {
      return <div className={styles.notesListContainer}>Loading…</div>;
    }

    const notes = TRUSEvents && TRUSEvents.filter(e => isHurdleNoteKind(e.kind));

    if (!notes || !notes.length) {
      return <div className={styles.notesListContainer}>No Notes added yet</div>;
    }

    return (
      <div className={styles.notesListContainer}>
        <ul className={styles.notes}>
          {sortByMostRecent(notes).map(n => (
            <li key={n.id}>
              <strong>{getHurdleName(n.kind)}</strong>
              <p>{n.fields.note}</p>
              <div className={styles.byline}>
                <time>
                  <FormattedDate
                    value={n.created_at}
                    year="numeric"
                    month="numeric"
                    day="numeric"
                    hour="numeric"
                    minute="numeric"
                  />
                </time>
                <span className={styles.author}>
                  {n.author_first_name && n.author_last_name
                    ? `${n.author_first_name} ${n.author_last_name}`
                    : n.author_email}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = ({ events }) => ({
  events,
});

const mapDispatchToProps = {
  loadEvents,
};

const ConnectedNotesList = connect<any, any>(mapStateToProps, mapDispatchToProps)(NotesList);

export default ConnectedNotesList;
